import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  deleteDoc,
} from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import CallPopup from './CallPopup';

const GlobalCallListener = () => {
  const [user] = useAuthState(auth);
  const [incomingCall, setIncomingCall] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    let unsubscribes = [];

    const listenToAllOffers = async () => {
      try {
        const chatSnapshot = await getDocs(collection(db, 'chats'));

        chatSnapshot.forEach((chatDoc) => {
          const chatData = chatDoc.data();
          const chatId = chatDoc.id;

          if (chatData.participants?.includes(user.uid)) {
            const offerRef = doc(db, `chats/${chatId}/offers/remoteOffer`);

            const unsubscribe = onSnapshot(offerRef, async (offerSnap) => {
              // ドキュメントが削除された場合
              if (!offerSnap.exists()) {
                setIncomingCall(null);
                return;
              }

              const offer = offerSnap.data();
              // 自分が発信者なら無視
              if (offer.uid === user.uid) return;

              // すでに通話画面なら無視（任意）
              if (location.pathname.startsWith(`/call/${chatId}`)) {
                return;
              }

              const callerDoc = await getDoc(doc(db, 'members', offer.uid));
              const callerName = callerDoc.exists()
                ? callerDoc.data().name
                : 'Unknown';

              setIncomingCall({ callerName, chatId });
            });

            unsubscribes.push(unsubscribe);
          }
        });
      } catch (error) {
        console.error('Error setting up call listeners:', error);
      }
    };

    listenToAllOffers();

    return () => {
      unsubscribes.forEach((unsubscribe) => unsubscribe());
    };
  }, [user, location]);

  const handleAnswer = () => {
    if (!incomingCall) return;
    navigate(`/call/${incomingCall.chatId}?answered=true`);
  };

  const handleReject = async () => {
    if (incomingCall) {
      try {
        await deleteDoc(doc(db, `chats/${incomingCall.chatId}/offers/remoteOffer`));
      } catch (e) {
        console.warn('Failed to delete remoteOffer on reject:', e);
      }
    }
    setIncomingCall(null);
  };

  if (!incomingCall) return null;

  return (
    <CallPopup
      callerName={incomingCall.callerName}
      onAnswer={handleAnswer}
      onReject={handleReject}
    />
  );
};

export default GlobalCallListener;
